import React from 'react';
import {Multilingual, TextInput, LongTextInput, CheckBox, DropdownSelector } from 'hyperdb-utils';
import ZonesAreasSelector from './ZonesAreasSelector';

const MultilingualLongTextInput = Multilingual(LongTextInput);

const LocationTab = ({ objectData, onChange, findZones, findAreas, countries, zones, areas, availableLocales, defaultLanguage }) => {
  const handleChangeAreasSelector = (attributeName, field) => {
    if (attributeName === 'areas') return onChange('areas', field);
    const { name, value } = field;
    const reference = { ...objectData[attributeName] };
    reference.value[1] = value;
    onChange(attributeName, { value: reference });
    if (attributeName === 'country') {
      handleChangeAreasSelector('zone', { value: null });
      if (value) findZones(value);
    }
    if (attributeName === 'zone') {
      onChange('areas', { value: [] });
      if (value) findAreas(value);
    }
  };
  const handleChangeLocalized = (attributeName, field) => {
    const { name, value } = field;
    onChange(attributeName, { value: { $i18n: value } });
  };
  return (
    <div>
      <fieldset>
        <ZonesAreasSelector
          objectData={ objectData }
          countries={ countries }
          zones={ zones }
          areas={ areas }
          defaultLanguage={ defaultLanguage }
          onChange={ handleChangeAreasSelector }
        />
        <TextInput
          label="Geographic position *"
          name="geoposition"
          value={ objectData.geoposition }
          onChange={ onChange.bind(null, 'geoposition') }
        />
        <TextInput
          label="Street address *"
          name="street_address"
          value={ objectData.street_address }
          onChange={ onChange.bind(null, 'street_address') }
        />
        <TextInput
          label="Extra address (building, door, floor, ...)"
          name="extra_address"
          value={ objectData.extra_address }
          onChange={ onChange.bind(null, 'extra_address') }
        />
        <TextInput
          label="Postcode *"
          name="postcode"
          value={ objectData.postcode }
          onChange={ onChange.bind(null, 'postcode') }
        />
        <TextInput
          label="Town/City *"
          name="locality"
          value={ objectData.locality }
          onChange={ onChange.bind(null, 'locality') }
        />
        <TextInput
          label="State/Province"
          name="administrative_area"
          value={ objectData.administrative_area }
          onChange={ onChange.bind(null, 'administrative_area') }
        />
        <MultilingualLongTextInput
          label="Arrival instructions"
          name="arrival_instructions"
          value={ objectData.arrival_instructions.$i18n }
          onChange={ handleChangeLocalized.bind(null, 'arrival_instructions') }
          availableLocales={ availableLocales }
        />
      </fieldset>
    </div>

  );
};

export default LocationTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/LocationTab.jsx